import { render } from "./image_step.vue?vue&type=template&id=4c2ebb3e"
import script from "./image_step.vue?vue&type=script&lang=js"
export * from "./image_step.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/image_step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c2ebb3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c2ebb3e', __exports__)) {
    api.reload('4c2ebb3e', __exports__)
  }
  
  module.hot.accept("./image_step.vue?vue&type=template&id=4c2ebb3e", () => {
    api.rerender('4c2ebb3e', render)
  })

}


export default __exports__